// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__sovAl","pagination":"style_pagination__19FvP","createButton":"style_createButton__2PMTw","wrapList":"style_wrapList__2jXou"};